// Cohesive, soft elevation scale built on a cool-grey (145,158,171) family
// rather than harsh black. Index 9 keeps the app's signature card shadow.
const shadows = [
  'none',
  '0px 1px 2px rgba(145,158,171,0.16)',
  '0px 2px 4px rgba(145,158,171,0.16)',
  '0px 3px 6px rgba(145,158,171,0.16)',
  '0px 4px 8px rgba(145,158,171,0.16)',
  '0px 5px 10px rgba(145,158,171,0.16)',
  '0px 6px 12px rgba(145,158,171,0.16)',
  '0px 7px 14px rgba(145,158,171,0.16)',
  '0px 8px 16px rgba(145,158,171,0.16)',
  'rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px',
  '0px 1px 4px rgba(145,158,171,0.12)',
  '0px 7px 14px rgba(145,158,171,0.18)',
  '0px 8px 16px rgba(145,158,171,0.18)',
  '0px 9px 18px rgba(145,158,171,0.18)',
  '0px 10px 20px rgba(145,158,171,0.18)',
  '0px 11px 22px rgba(145,158,171,0.18)',
  '0px 12px 24px rgba(145,158,171,0.18)',
  '0px 13px 26px rgba(145,158,171,0.18)',
  '0px 14px 28px rgba(145,158,171,0.18)',
  '0px 15px 30px rgba(145,158,171,0.18)',
  '0px 16px 32px rgba(145,158,171,0.20)',
  '0px 18px 36px rgba(145,158,171,0.20)',
  '0px 20px 40px rgba(145,158,171,0.20)',
  '0px 22px 44px rgba(145,158,171,0.20)',
  '0px 24px 48px rgba(145,158,171,0.20)',
];

export { shadows };
